import PharmacyNav from "../../pages/Dashboard/Pharmacy/PharmacyNav";
import Pos from "../../pages/Dashboard/Pharmacy/POS/Pos";
import AddPrescription from "../../pages/Dashboard/Pharmacy/prescription/Prescription";
import AddMedicine from "../../pages/Dashboard/Pharmacy/medicine/addMedicine/AddMedicine";
import ListMedicine from "../../pages/Dashboard/Pharmacy/medicine/ListMedicine/ListMedicine";
import PharmacyIndex from "../../pages/Dashboard/Pharmacy/PharmacyIndex";
import PurchaseDrug from "../../pages/Dashboard/Pharmacy/PurchaseDrug/PurchaseDrug";
import MedicineStock from "../../pages/Dashboard/Pharmacy/stock/MedicineStock";
import MedicineExpirySexMonthLater from "../../pages/Dashboard/Pharmacy/MedicineExpirySexMonthLater/MedicineExpirySexMonthLater";
import SurgeryPrescription from "../../pages/Dashboard/Pharmacy/surgeryPrescription/SurgeryPrescription";
import LowQuantityStockMedicine from "../../pages/Dashboard/Pharmacy/LowQuantityStockMedicine/LowQuantityStockMedicine";
import AddReturnMedicine from "../../pages/Dashboard/Pharmacy/ReturnMedicine/addReturnMedicine/AddReturnMedicine";
import MedicineOrderList from "../../pages/Dashboard/Pharmacy/POS/PosList";
import PrescriptionList from "../../pages/Dashboard/Pharmacy/prescription/PrescriptionList";
import SurgeryPrescriptionList from "../../pages/Dashboard/Pharmacy/surgeryPrescription/SurgeryPrescriptionList";
import ListCompanyMedicine from "../../pages/Dashboard/Pharmacy/companyMedicine/ListCompanyMedicine/ListCompanyMedicine";
import AddCompanyMedicine from "../../pages/Dashboard/Pharmacy/companyMedicine/addCompanyMedicine/AddCompanyMedicine";
import PurchaseDrugList from "../../pages/Dashboard/Pharmacy/PurchaseDrug/PurchaseDrugList";
import ListReturnMedicine from "../../pages/Dashboard/Pharmacy/ReturnMedicine/addReturnMedicine/ListReturnMedicine";

const pharmacyRoutes = {
  path: "/pharmacy",
  element: <PharmacyNav />,
  children: [
    { path: "/pharmacy", element: <PharmacyIndex /> },
    { path: "/pharmacy/pos", element: <MedicineOrderList /> },
    { path: "/pharmacy/pos/add", element: <Pos /> },
    { path: "/pharmacy/prescription", element: <PrescriptionList /> },
    { path: "/pharmacy/prescription/add", element: <AddPrescription /> },
    {
      path: "/pharmacy/surgery-prescription",
      element: <SurgeryPrescriptionList />,
    },
    {
      path: "/pharmacy/surgery-prescription/add",
      element: <SurgeryPrescription />,
    },
    { path: "/pharmacy/new-medicine", element: <AddMedicine /> },
    { path: "/pharmacy/medicine-list", element: <ListMedicine /> },
    { path: "/pharmacy/medicine-company", element: <ListCompanyMedicine /> },
    { path: "/pharmacy/medicine-company/add", element: <AddCompanyMedicine /> },
    { path: "/pharmacy/purchase-drug", element: <PurchaseDrugList /> },
    { path: "/pharmacy/purchase-drug/add", element: <PurchaseDrug /> },
    {
      path: "/pharmacy/return-medicine",
      element: <ListReturnMedicine />,
    },
    {
      path: "/pharmacy/return-medicine/add",
      element: <AddReturnMedicine />,
    },
    { path: "/pharmacy/medicine-stock", element: <MedicineStock /> },
    {
      path: "/pharmacy/medicine-expiry-six-months",
      element: <MedicineExpirySexMonthLater />,
    },
    {
      path: "/pharmacy/low-quantity-stock",
      element: <LowQuantityStockMedicine />,
    },
  ],
};

export default pharmacyRoutes;
